import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_MDTEX2HTML + '/cvt/mdtex2html'

const convert = params => {
  return Repository(baseURL).create(params)
}

export default {convert}
